import { CSSProperties } from 'react'

const styles: { video: CSSProperties; placeholder: CSSProperties } = {
  video: {
    backgroundColor: 'black',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 0,
    height: '100%',
    width: '100%',
  },
  placeholder: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'black',
  },
}

export default styles
